import NetInfo, { addEventListener, fetch } from '@react-native-community/netinfo';

export type NetworkListener = (isConnected: boolean) => void;
export type Unsubscribe = () => void;

const NetworkService = {
	addNetworkListener(callback: NetworkListener): Unsubscribe {
		return addEventListener((state) => {
			callback(state.isConnected ?? true);
		});
	},

	async isConnected(): Promise<boolean> {
		const state = await fetch();
		return state.isConnected ?? true;
	},

	netInfo: NetInfo,
};

export default NetworkService;
